import { post } from '@utils/request';
import { get } from '../utils/request';

//  拼团成功订单列表
export const groupBuyOrderRequest = params => get('shop/order/queryOrderDetail', params);

//  获取拼团详情
export const getPtInfo = params => get('shop/pt/getPtInfo', params);
export const getPtUrl = (params) => get('shop/pt/poster/get', params);

//  获取成功页是否弹窗
export const getMarkSuccessAlert = params => get('guide/getUserTagGuide', params);

export const orderRequest = (data, config) => post('shop/order/submitShopOrder', data, config);

export const getOrderList = params => get('shop/order/myShopOrder', params);

//  获取拼团订单列表
export const getPtOrderList = params => get('shop/pt/getPtOrderPage', params);

export const getOutOrderList = params => get('order/getListForTrainingCamp', params, { outOrder: true });

export const checkStatusFromWechat = params => get('order/queryWechatPayStatus', params);

export const requestUrl = '/mall-server/api/shop/order/submitShopOrder';
export const checkStatus = params => get('order/queryPayStatus', params);
export const getSkuGuide = params => get('guide/skuGuide', params);

// 获取花呗分期结算
export const getSettleAccount = data => post('coupon/hbfqCaculate', data);

// 是否支持余额支付
export const isBalancePay = data => post('coupon/queryBalancePay', data);

// 拼团下单接口
export const postSubmitPtOrder = data => post('shop/pt/submitPtOrder', data);

// 获取urlscheme
export const postUrlscheme = data => post('shop/wx/getUrlScheme', data);

/**
 * 获取urlschemeV2, 小程序+V备份版本添加，主要对scheme进行是否可用校验
 * @param {*} data
 * @returns
 */
export const postUrlschemeV2 = data => post('shop/wx/getUrlSchemeV2', data);

// 请求接口获取小程序 url Scheme
/**
 * params: {
 *  orderId: string  订单ID
 *  type: number 默认为0  0是抖音成功去页面  1 是支付成功选择年级页面   后选择年级页面
 * }
 */
export const getGenerateScheme = params => get('wechatJoinGroup/generateScheme', params);
class Pay {
  constructor(params, type = 'h5') {
    this.type = type;
    this.params = params;
  }

  request() {
    if (this.type === 'wechat') {
      return this.weChatPay();
    }
    if (this.type === 'app') {
      return this.appPay();
    }
    return this.h5Pay(this.params);
  }

  h5Pay() {
    this.params.shopPayType = 0;
    return orderRequest(this.params);
  }

  weChatPay() {
    this.params.shopPayType = -1;
    function onBridgeReady() {
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          'appId': 'wx2421b1c4370ec43b',     // 公众号名称，由商户传入
          'timeStamp': '1395712654',         // 时间戳，自1970年以来的秒数
          'nonceStr': 'e61463f8efa94090b1f366cccfbbb444', // 随机串
          'package': 'prepay_id=u802345jgfjsdfgsdg888',
          'signType': 'MD5',         // 微信签名方式：
          'paySign': '70EA570631E4BB79628FBCA90534C63FF7FADD89' // 微信签名
        },
        function(res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {

            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        });
    }
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
      }
    } else {
      onBridgeReady();
    }
  }

  appPay() {
    this.params.shopPayType = 2;
    return orderRequest(this.params);
  }
}

/**
 * 检查体验课上课时间是否冲突
 * 检查体验课上课时间
 * skuId
 */
export const getChecktExperienceTime = (params, config = {}) => get('shop/cart/checktExperienceTime', params, config);



/**
 * 通过商品id查询对应的活动和加购商品id
 * skuId
 */
export const getTrolleyGoods = params => get('shop/trolley/activity/getTrolleyGoods', params);

/**
 * app内获取当前使用中的小程序信息
 * @param {*} params
 * @returns
 */
export const getAppWechatInfo = params => get('shop/wx/getAppWechatInfo', params);

/**
 * 获取第三方应用信息
 * @param {*} params
 * appId: string 第三方appId
 * @returns
 */
export const getThirdAppInfo = params => get('shop/order/getThirdAppInfo', params);

/**
 * 商城 - 拼团 - 一元加购支持用户加老师
 * orderSystemId: 订单号
 */
export const getPtOneTeacherCode = params => get('shop/pt/one/teacher/code', params);

/**
 * 根据内部信息查询支付订单信息
 * @param {*} params
 */
export const queryYbPay = params => get('order/yb/pay/query', params);

/**
 * 在商家小票中调用
 * 根据商户订单id获取订单详情
 * outTradeNo: 商户订单号
 */
export const getYbPayQueryV2 = params => get('order/yb/pay/query/v2', params);

export default Pay;

// 获取订单详情
export const getOrderDetailV2 = params => get('shop/order/queryOrderDetail/v2', params);
// 获取是否能易宝支付
export const getYbPayStatus = data => post('coupon/activity/yibao/pay', data);

// @aigc:start 2024/09/23-11:11
// 获取正在使用的公众号
export const getInUseAppId = data => post('yb/inEffectAppId', data);
// @aigc:end 2024/09/23-11:11

// 计算订单价格
export const caculateOrderPrice = ({ data, cancelToken }) => post('coupon/calculatePrice', data, { cancelToken });
// 获取蜻蜓FM交付状态
export const getQingtingFm = params => get('guide/qingting/fm/order/get', params);

// 获取不需要展示权益券的商品id
// @aigc:start 2024/09/24-11:05
export const getNoShowCouponGoods = params => get('goods/goodsIds', params);
// @aigc:end 2024/09/24-11:05
